import { createContext, ReactNode, useContext, useState } from 'react'

interface FormData {
  first_name: string
  last_name: string
  address: string
  address_optional: string
  city: string
  state: string
  zip_code: string
}

type WizardContext = {
  formData: FormData
  updateFormData: (field: keyof FormData, value: any) => void
}

const Context = createContext<WizardContext | undefined>(undefined)

export const IdentityVerificationWizardProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const [formData, setFormData] = useState<FormData>({
    first_name: '',
    last_name: '',
    address: '',
    address_optional: '',
    city: '',
    state: '',
    zip_code: '',
  })

  const updateFormData = (field: keyof FormData, value: any) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }))
  }

  return (
    <Context.Provider
      value={{
        formData,
        updateFormData,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export const useWizardContext = () => {
  const context = useContext(Context)

  if (context === undefined)
    throw new Error('useWizardContext must be used within the WizardProvider')
  return context
}
